import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { MapPin, Clock, DollarSign, User, ArrowLeft, CheckCircle, Mail, Calendar } from 'lucide-react';
export function AdministrativeAssistant() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1496" data-mp="crkmebybqh9y">
      <Header data-id="element-1497" data-mp="cs2q1tnbfxrw" />
      <main className="flex-grow" data-id="element-1498" data-mp="cpgkfzjzjscb">
        {/* Header Section */}
        <section className="bg-navy-50 py-12" data-id="element-1499" data-mp="10i6rbud17lfq">
          <div className="container mx-auto px-4" data-id="element-1500" data-mp="10fay2jc4pkxm">
            <div className="max-w-4xl mx-auto" data-id="element-1501" data-mp="14hfnf5vjnveg">
              <a href="/careers" className="inline-flex items-center text-teal-600 hover:text-teal-700 mb-6 transition-colors" data-id="element-1502" data-mp="qiy3zkco952c">
                <ArrowLeft size={20} className="mr-2" data-id="element-1503" data-mp="vg7s8wobraol" />
                Back to Careers
              </a>
              <h1 className="text-3xl md:text-4xl font-bold text-navy-800 mb-4" data-id="element-1504" data-mp="3bb9o1qcsmua3">
                Administrative Assistant to the Director
              </h1>
              <div className="flex flex-wrap gap-4 text-navy-600" data-id="element-1505" data-mp="31q7007j7btbw">
                <div className="flex items-center" data-id="element-1506" data-mp="2xntvfmg6y1gp">
                  <MapPin size={18} className="mr-2 text-teal-600" data-id="element-1507" data-mp="2xp50dpldhf9e" />
                  <span data-id="element-1508" data-mp="3bnlfa3te2c2m">Pattaya, Thailand</span>
                </div>
                <div className="flex items-center" data-id="element-1509" data-mp="36o8k8vsd5yoy">
                  <Clock size={18} className="mr-2 text-teal-600" data-id="element-1510" data-mp="36ngva3t9uz7n" />
                  <span data-id="element-1511" data-mp="3knhw5j9je6n4">Full-Time | On-Site</span>
                </div>
                <div className="flex items-center" data-id="element-1512" data-mp="3klnfwi97n2pd">
                  <DollarSign size={18} className="mr-2 text-teal-600" data-id="element-1513" data-mp="3glmxynmwk9dk" />
                  <span data-id="element-1514" data-mp="3ueckqua99ibq">30,000 THB/month</span>
                </div>
                <div className="flex items-center" data-id="element-1515" data-mp="3ufnoiu3paq2u">
                  <User size={18} className="mr-2 text-teal-600" data-id="element-1516" data-mp="3pg1c2mvp5dv3" />
                  <span data-id="element-1517" data-mp="86cy7m6hjg8y">Reports to: Azn Alahah</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Job Description */}
        <section className="py-12" data-id="element-1518" data-mp="35p1cjvks56t">
          <div className="container mx-auto px-4" data-id="element-1519" data-mp="abhq54xw2uvt">
            <div className="max-w-4xl mx-auto" data-id="element-1520" data-mp="a8n6vgqm3g3z">
              <div className="bg-white rounded-lg shadow-sm border border-navy-100 p-8 mb-8" data-id="element-1521" data-mp="f91gv4brx04n">
                <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-1522" data-mp="k8mdv97duyeq">
                  About the Role
                </h2>
                <p className="text-navy-700 mb-4" data-id="element-1523" data-mp="p0e6rqe0hg81">
                  We are seeking a highly organized, reliable, and proactive
                  Administrative Assistant to support Chief R&D Officer Azn
                  Alahah in managing a fast-growing, multi-venture
                  international ecosystem spanning hospitality, wellness, real
                  estate, logistics, and digital media.
                </p>
                <p className="text-navy-700" data-id="element-1524" data-mp="17we0p6qjutu9">
                  This role requires someone sharp, disciplined, and trustworthy
                  who can keep operations running smoothly while handling a wide
                  range of responsibilities.
                </p>
              </div>

              {/* Responsibilities */}
              <div className="bg-white rounded-lg shadow-sm border border-navy-100 p-8 mb-8" data-id="element-1525" data-mp="2xfvrmye6tj2m">
                <h2 className="text-2xl font-bold text-navy-800 mb-6" data-id="element-1526" data-mp="2sg9f6r66o6uv">
                  Responsibilities
                </h2>
                <ul className="space-y-3" data-id="element-1527" data-mp="2nihcr37wx2cf">
                  {['Provide daily administrative and operational support to the Director', 'Manage schedules, appointments, reminders, and travel arrangements', 'Prepare documents, presentations, reports, and spreadsheets', 'Communicate professionally with staff, clients, partners, and vendors', 'Assist with operations across real estate units and hospitality properties', 'Handle bill tracking, rent collection, contract organization, and maintenance coordination', 'Support guest communication, bookings, and check-ins', 'Maintain digital files, receipts, and basic accounting entries', 'Conduct research on suppliers, services, regulations, immigration matters, and pricing', 'Coordinate meetings, events, and local activities', 'Perform occasional errands or onsite tasks', 'Maintain strict confidentiality at all times'].map((responsibility, index) => <li key={index} className="flex items-start" data-id="element-1528" data-mp="b6v0ga9w073z" data-mpi={index}>
                      <CheckCircle size={20} className="text-teal-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-1529" data-mp="b6d4ler4zuwl" />
                      <span className="text-navy-700" data-id="element-1530" data-mp="17xbj68jubkg">{responsibility}</span>
                    </li>)}
                </ul>
              </div>

              {/* Requirements */}
              <div className="bg-white rounded-lg shadow-sm border border-navy-100 p-8 mb-8" data-id="element-1531" data-mp="2m08x5gobk8ub">
                <h2 className="text-2xl font-bold text-navy-800 mb-6" data-id="element-1532" data-mp="140i24zjgivxt">
                  Requirements
                </h2>
                <ul className="space-y-3" data-id="element-1533" data-mp="z1ybiltx4vz4">
                  {['Strong English communication skills (written & spoken)', 'Thai language proficiency (native or fluent)', 'Highly organized with excellent attention to detail', 'Ability to multitask and prioritize in a fast-moving environment', 'Tech-savvy: Google Workspace, spreadsheets, messaging apps', 'Proactive problem-solver with a positive, professional attitude', 'Must be based in Pattaya or able to commute reliably', 'Previous experience in admin, operations, hospitality, or property management preferred', 'Honesty, reliability, and discretion are essential'].map((requirement, index) => <li key={index} className="flex items-start" data-id="element-1534" data-mp="1wqsamceio0wr" data-mpi={index}>
                      <CheckCircle size={20} className="text-teal-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-1535" data-mp="1woehi93ecyru" />
                      <span className="text-navy-700" data-id="element-1536" data-mp="26gk8pgltrc5z">{requirement}</span>
                    </li>)}
                </ul>
              </div>

              {/* Preferred Skills */}
              <div className="bg-navy-50 rounded-lg p-8 mb-8" data-id="element-1537" data-mp="1dsoau8kire7m">
                <h2 className="text-2xl font-bold text-navy-800 mb-6" data-id="element-1538" data-mp="1ipy1frjn9vx1">
                  Preferred Skills
                </h2>
                <ul className="space-y-3" data-id="element-1539" data-mp="1norfpm6r9qy9">
                  {['Hospitality or property management experience', 'Basic bookkeeping or financial tracking', 'Familiarity with government paperwork or visa/immigration procedures', 'Vendor coordination experience (cleaners, maintenance workers, service providers)', 'Social media or content-support skills'].map((skill, index) => <li key={index} className="flex items-start" data-id="element-1540" data-mp="nioyyrqctuq8" data-mpi={index}>
                      <div className="w-2 h-2 bg-teal-600 rounded-full mr-3 mt-2 flex-shrink-0" data-id="element-1541" data-mp="iq48o06npzrg"></div>
                      <span className="text-navy-700" data-id="element-1542" data-mp="ds2sbn0m8ejo">{skill}</span>
                    </li>)}
                </ul>
              </div>

              {/* Compensation & Benefits */}
              <div className="bg-white rounded-lg shadow-sm border border-navy-100 p-8 mb-8" data-id="element-1543" data-mp="4qczqduzz9kb">
                <h2 className="text-2xl font-bold text-navy-800 mb-6" data-id="element-1544" data-mp="3vwnuxtdbtg3q">
                  Compensation & Benefits
                </h2>
                <div className="grid md:grid-cols-2 gap-6" data-id="element-1545" data-mp="3qze7gj9hzeij">
                  <div data-id="element-1546" data-mp="1u5kmnaqwsdmc">
                    <h3 className="font-bold text-navy-800 mb-3" data-id="element-1547" data-mp="1u4rmwtqdaodp">
                      Compensation
                    </h3>
                    <ul className="space-y-2" data-id="element-1548" data-mp="1p7j0ui23m076">
                      <li className="flex items-start" data-id="element-1549" data-mp="y0u5hugixfcw">
                        <CheckCircle size={18} className="text-teal-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-1550" data-mp="y25i8jry5xg5" />
                        <span className="text-navy-700" data-id="element-1551" data-mp="oastw25cxpev">
                          30,000 THB per month
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1552" data-mp="fb5t9ikgcnmv">
                        <CheckCircle size={18} className="text-teal-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-1553" data-mp="f9kvzl6r6qlb" />
                        <span className="text-navy-700" data-id="element-1554" data-mp="5dzy9z8pwchd">
                          Paid twice per month (mid-month & end of month)
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1555" data-mp="1zrsjgq0blq57">
                        <CheckCircle size={18} className="text-teal-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-1556" data-mp="24pu1r8px9lfm" />
                        <span className="text-navy-700" data-id="element-1557" data-mp="3p84o1a6prrlj">
                          Performance bonuses
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div data-id="element-1558" data-mp="2ud3ojvou238">
                    <h3 className="font-bold text-navy-800 mb-3" data-id="element-1559" data-mp="3u77riq71ppre">Benefits</h3>
                    <ul className="space-y-2" data-id="element-1560" data-mp="3u54rreg3ci9h">
                      <li className="flex items-start" data-id="element-1561" data-mp="brx5pv1dk2ew">
                        <CheckCircle size={18} className="text-teal-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-1562" data-mp="but1pdtnwh0p" />
                        <span className="text-navy-700" data-id="element-1563" data-mp="lqcwfwwhp9nv">
                          Long-term, stable role with growth opportunities
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1564" data-mp="2nj12ee0iqb7c">
                        <CheckCircle size={18} className="text-teal-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-1565" data-mp="2ijxxctkjg4zd" />
                        <span className="text-navy-700" data-id="element-1566" data-mp="2q78qsqh9x2ar">
                          Direct mentorship from the Chief R&D Officer
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1567" data-mp="2la8ngnbt6dnc">
                        <CheckCircle size={18} className="text-teal-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-1568" data-mp="2h7m0azq31gwh" />
                        <span className="text-navy-700" data-id="element-1569" data-mp="38x8dx7tk07bj">
                          Opportunities to move into senior operations roles
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1570" data-mp="305ogqq4ke5io">
                        <CheckCircle size={18} className="text-teal-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-1571" data-mp="3056fff31p13w" />
                        <span className="text-navy-700" data-id="element-1572" data-mp="3rvt0cmki2oiu">
                          Exposure to multiple industries and international
                          projects
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* How to Apply */}
              <div className="bg-teal-50 rounded-lg border-2 border-teal-200 p-8" data-id="element-1573" data-mp="1sdpwsz8dcah7">
                <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-1574" data-mp="1sbmxtpp8n70c">
                  How to Apply
                </h2>
                <p className="text-navy-700 mb-6" data-id="element-1575" data-mp="22bnl1mq8a79t">
                  Please send the following to{' '}
                  <a href="mailto:careers@calmir.org" className="text-teal-600 hover:text-teal-700 font-medium" data-id="element-1576" data-mp="272vwspf164q5">
                    careers@calmir.org
                  </a>
                  :
                </p>
                <ul className="space-y-3 mb-6" data-id="element-1577" data-mp="2g17l2ksfcqff">
                  <li className="flex items-start" data-id="element-1578" data-mp="2l1lotqmzte7n">
                    <Mail size={18} className="text-teal-600 mr-3 mt-0.5" data-id="element-1579" data-mp="2l02a44gzjb7z" />
                    <span className="text-navy-700" data-id="element-1580" data-mp="l0f6id57fi5o">CV/Resume</span>
                  </li>
                  <li className="flex items-start" data-id="element-1581" data-mp="g2ng5nk7k43l">
                    <Mail size={18} className="text-teal-600 mr-3 mt-0.5" data-id="element-1582" data-mp="upp0jyjlzawf" />
                    <span className="text-navy-700" data-id="element-1583" data-mp="urrzj82qoeda">Short introduction</span>
                  </li>
                  <li className="flex items-start" data-id="element-1584" data-mp="pxfdqrdsiqyd">
                    <Calendar size={18} className="text-teal-600 mr-3 mt-0.5" data-id="element-1585" data-mp="13plvghwld5zx" />
                    <span className="text-navy-700" data-id="element-1586" data-mp="zpl4jxsb32bz">Expected start date</span>
                  </li>
                </ul>
                <a href="mailto:careers@calmir.org?subject=Application: Administrative Assistant to the Director" className="inline-block px-6 py-3 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors duration-200 shadow-sm" data-id="element-1587" data-mp="1dnrqqgnw7dvt">
                  Apply Now
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-1588" data-mp="1pzu774fcax04" />
    </div>;
}